import { type ReactElement } from 'react'
import { TButton, type TButtonProps } from './button'

type Props = Omit<TButtonProps, 'icon' | 'variant' | 'buttonType'>

export const ButtonReset = (props: Props): ReactElement => {
  return <TButton {...props} buttonType='icon-rounded' icon='undo' variant='secondary' />
}
